import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const InfoRestaurantOrdersTableHead = (props) => {
  const { t } = useTranslation();

  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    {
      id: 'reference',
      label: t('RestaurantOrders.table.head.reference'),
      align: 'left',
    },
    {
      id: 'client.user.firstName',
      label: t('RestaurantOrders.table.head.client'),
      align: 'left',
    },
    {
      id: 'status.description',
      label: t('RestaurantOrders.table.head.status'),
      align: 'left',
    },
    {
      id: 'createdAt',
      label: t('RestaurantOrders.table.head.createdAt'),
      align: 'left',
    },
    {
      id: 'orderCost.productsCost',
      label: t('RestaurantOrders.table.head.productsCost'),
      align: 'left',
    },
    {
      id: 'orderCost.taxes',
      label: t('RestaurantOrders.table.head.orderTaxes'),
      align: 'left',
    },
    {
      id: 'orderCost.total',
      label: t('RestaurantOrders.table.head.total'),
      align: 'left',
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding="center"
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              disabled={true}>
              <strong>{headCell.label}</strong>
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

InfoRestaurantOrdersTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
